/* eslint-disable react-hooks/exhaustive-deps */
import { corporationAtom } from '@/state/atom/corporationAtom';
import { closePanelTabSelector, setPanelSelector, updateParamIsCustomerKnowledgeDrilldown } from '@/state/selector/panelSelector';
import { useEffect, useState } from 'react';
import { useRecoilState, useRecoilValue, useSetRecoilState, useResetRecoilState } from 'recoil';
import LoadingPanel from '../common/LoadingPanel';
import FirstMessageContent from './element/FirstMessageContent';
import GroupButtonKnowledge from './element/GroupButtonKnowledge';
import InputChatAI from './element/InputChatAI';
import ListMessageChatAI from './element/ListMessageChatAI';
import { getProjectInfo, isValidSearchConditionData, onSubscriptionEventUpdateCorporation, updateChatAIInvalidPreconditionStatus, fetchChatAiConfigurations } from './handler/ChatAIHandler';
import { getListMessageChat, getNameTabChatAiWhenFirstMsgNoContent } from '@/service/chatAIService';

import Utils from '@/common/utils/utils';
import { formatUserDateTime } from '@/common/utils/timezoneUtils';
import Constant from '@/common/constant/Constant';
import AiAutoConstant from "@/common/constant/AiAutoConstant";
import {showLoadingMouse, hideLoadingMouse} from '@/common/utils/CustomCursor';

import { userAtom, userPermissionToViewKnowledgeAtom } from '@/state/atom/userAtom';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import API from '@/amplify/api';
import { multiPanelAtom } from '@/state/atom/panelAtom';
import { cloneDeep } from 'lodash';
import { projectInuseDetailAtom } from '@/state/atom/projectAtom';
import DataChangePleaseReloadModal from '../common/modal/DataChangePleaseReloadModal';
import { helpdeskTicketLastUserActionAtom, publicKnowledgeHitNumberTicketAtom } from '@/state/atom/ticketAtom';
import { projectIdListUserIsB2CAtom } from '@/state/atom/projectAtom';
import { openShareLinkTicket } from '../chatThread/handler/MessageHandler';
import { getCorporationById } from '@/service/organizationService';
import './ChatAIPanel.css';

import APIAmplify from '@/amplify/api';
import { onAIChatPostCreated } from '@/graphql/subscriptions';
import { PropTypes } from 'prop-types';
import OpenAiUtil from '@/common/utils/OpenAiUtil';

import { kboardPendingResultAtom } from '@/state/atom/kboardAtom';
import { handleDataFromKboard } from '@/component/chatAI/element/InputChatAiGroupButtons/handler/KBoardConnectHandler';
import { setRecoil } from 'recoil-nexus';
import trI18n from '@/common/utils/trI18n';
import { tr } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';

ChatAI.propTypes = {
    panelId: PropTypes.any,
    tabId: PropTypes.any,
    tabNameChatAI: PropTypes.any,
    filterKnowledgeListData: PropTypes.any
};

export default function ChatAI(props) {
    // Re-render when the translation dictionary loads/extends so tr() text updates.
    useTranslationSubscription();

    // ==================== Props derived values ====================
    const filterKnowledgeListData = props?.filterKnowledgeListData;
    const chatThreadId = filterKnowledgeListData?.threadId;
    const isAiAutoLog = !!filterKnowledgeListData?.aiAutoLog;

    const usingBasicPrompt = filterKnowledgeListData?.hasOwnProperty('usingBasicPrompt')
        ? filterKnowledgeListData.usingBasicPrompt
        : true;
    const resetSearchCondition = filterKnowledgeListData?.hasOwnProperty('resetSearchCondition')
        ? filterKnowledgeListData.resetSearchCondition
        : false;

    const isInvalidPrecondition = filterKnowledgeListData?.hasOwnProperty('isInvalidPrecondition')
        ? filterKnowledgeListData.isInvalidPrecondition
        : false;

    // ==================== Recoil state ====================
    const [currentUserDetail, setCurrentUserDetail] = useRecoilState(userAtom);
    const [corporationDetail, setCorporationDetail] = useRecoilState(corporationAtom);
    const [projectInuseDetail, setProjectInuseDetail] = useRecoilState(projectInuseDetailAtom);
    const [panelList, setPanelList] = useRecoilState(multiPanelAtom);

    const totalTickets = useRecoilValue(publicKnowledgeHitNumberTicketAtom);
    const userPermissionView = useRecoilValue(userPermissionToViewKnowledgeAtom);
    const kboardPendingResult = useRecoilValue(kboardPendingResultAtom);

    const reloadKnowledgeDrilldownIsCustomerParams = useSetRecoilState(updateParamIsCustomerKnowledgeDrilldown);
    const closePanelTab = useSetRecoilState(closePanelTabSelector);
    const addNewPanel = useSetRecoilState(setPanelSelector);
    const setProjectIdListUserIsB2CAtom = useSetRecoilState(projectIdListUserIsB2CAtom);
    const setLastUserAction = useSetRecoilState(helpdeskTicketLastUserActionAtom);

    const resetKboardPendingResult = useResetRecoilState(kboardPendingResultAtom);

    // ==================== Corporation / Contract derived ====================
    const { corporationSetting, limitValue, inviterSetting, contractType } = corporationDetail || {};
    const isGuestContract = [
        Constant.CORPORATION_CONTRACT_TYPE.GUEST,
        Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK
    ].includes(contractType);

    const chatGptModelOfCorp = isGuestContract
        ? Utils.convertJSONDataToObject(inviterSetting)?.chatGPTModel
        : Utils.convertJSONDataToObject(corporationSetting)?.chatGPTModel
        || Utils.convertJSONDataToObject(limitValue)?.chatGPTModel;

    let usingChatGptModelDefault = filterKnowledgeListData?.hasOwnProperty('usingChatGptModel')
        ? filterKnowledgeListData.usingChatGptModel
        : chatGptModelOfCorp;

    const usingReasoingEffortDefault = filterKnowledgeListData?.hasOwnProperty('usingReasoningEffort')
        ? filterKnowledgeListData.usingReasoningEffort
        : OpenAiUtil.defaultReasoningEffort(usingChatGptModelDefault);

    let usingSelectedMcpListDefault = filterKnowledgeListData?.hasOwnProperty('listSelectedMcp')
        ? filterKnowledgeListData.listSelectedMcp
        : [];

    const initHitNumber = filterKnowledgeListData?.hasOwnProperty('hitNumber')
        ? filterKnowledgeListData.hitNumber
        : totalTickets;

    // ==================== Local state: Loading / UI ====================
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingMessage, setIsLoadingMessage] = useState(true);
    const [isReloadPage, setIsReloadPage] = useState(false);
    const [isOpenModalReloadPage, setIsOpenModalReloadPage] = useState(false);
    const [isEnableBtnSend, setIsEnableBtnSend] = useState(true);
    const [triggerReload, setTriggerReload] = useState('');

    // ==================== Local state: Chat messages ====================
    const [listMessageContent, setListMessageContent] = useState([]);
    const [idOfResponseMessage, setIdOfResponseMessage] = useState('');
    const [streamedContent, setStreamedContent] = useState('');
    const [isStopStreamContent, setIsStopStreamContent] = useState('');
    const [isShowButtonStop, setIsShowButtonStop] = useState(false);
    const [isOnlyRunChatAI, setIsOnlyRunChatAI] = useState(false);
    const [reasoningDataStream, setReasoningDataStream] = useState([]);

    // ==================== Local state: Project / Prompt ====================
    const [projectInfo, setProjectInfo] = useState({});
    const [titleTicket, setTitleTicket] = useState('');
    const [basicPrompt, setBasicPrompt] = useState('');
    const [promptInternalTicket, setPromptInternalTicket] = useState({});
    const [promptExternalTicket, setPromptExternalTicket] = useState({});
    const [userSelectedPrompt, setUserSelectedPrompt] = useState([]);
    const [aiAutoPromptTitle, setAiAutoPromptTitle] = useState('');

    // ==================== Local state: Corporation / Knowledge ====================
    const [corporationSelected, setCorporationSelected] = useState('');
    const [isUsingKnowledgeService, setIsUsingKnowledgeService] = useState(false);
    const [toggleUsingKnowledgeTicketList, setToggleUsingKnowledgeTicketList] = useState(!resetSearchCondition);
    const [isInvalidSearchCondition, setIsInvalidSearchCondition] = useState(false);

    // ==================== Local state: ChatGPT Model / MCP ====================
    const [usingChatGptModel, setUsingChatGptModel] = useState(usingChatGptModelDefault);
    const [usingReasoningEffort, setUsingReasoningEffort] = useState(usingReasoingEffortDefault);
    const [chatGPTModelListOptions, setChatGPTModelListOptions] = useState([]);
    const [mcpServerOptions, setMcpServerOptions] = useState([]);
    const [selectedMcpServers, setSelectedMcpServers] = useState(usingSelectedMcpListDefault);

    // ==================== Local state: Popups / Dialogs ====================
    const [isOpenPopupKnowledgeOff, setIsOpenPopupKnowledgeOff] = useState(false);
    const [isOpenAccessDeniedPopup, setIsOpenAccessDeniedPopup] = useState(false);
    const [isOpenNotFoundTicketPopup, setIsOpenNotFoundTicketPopup] = useState(false);
    const [showPopupSingleButtonError, setShowPopupSingleButtonError] = useState({
        isShow: false,
        message: trI18n('MSG-CM-DELETED-CONTENT'),
        confirmTxt: trI18n('CM-BUTTON-OK')
    });

    const reOpenKnowledgePanel = async () => {
        setIsLoading(true);
        let isValidCondition = await isValidSearchConditionData(
            props?.API,
            projectInuseDetail,
            props?.filterKnowledgeListData?.projectIdKnowledgeSelected,
            projectInfo,
            props?.filterKnowledgeListData?.viewSelectedId,
            currentUserDetail,
            userPermissionView,
            setProjectIdListUserIsB2CAtom,
            panelList,
            setPanelList
        );

        setIsLoading(false);
        if (!isValidCondition) {
            if (projectInuseDetail.type === Constant.PROJECT_TYPE.CUSTOMER) {
                setIsReloadPage(true);
                return;
            }
            setIsInvalidSearchCondition(true);
            return;
        }

        const existedPanel = panelList.find(panel => (Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST).includes(panel.type));
        if (!Utils.isEmptyObject(existedPanel)) {
            closePanelTab({
                event: null,
                panelType: existedPanel.type,
                panelId: existedPanel.id,
                tabId: 'knowledge_ticket_list_tab'
            });
        }

        const propsClone = cloneDeep(props);
        // delete propsClone.panelId;
        delete propsClone.filterKnowledgeListData;

        let addNewPanelParams = {
            type: Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST,
            componentName: Constant.COMPONENT_NAME.LIST_TICKET_KNOWLEDGE,
            tabId: 'knowledge_ticket_list_tab',
            existedKnowledgePanel: existedPanel,
            visibilitySettingType: props?.filterKnowledgeListData?.visibilityKnowledgeAtom ? props?.filterKnowledgeListData?.visibilityKnowledgeAtom : Constant.VISIBILITY_SETTING_TYPE.PRIVATE,
            isCustomer: false,
            projectSelectedId: props?.filterKnowledgeListData.projectIdKnowledgeSelected,
            corporationSelectedId: corporationSelected,
            knowledgeInfoChatAi: {
                viewSelectedId: props?.filterKnowledgeListData.viewSelectedId,
                viewSelected: props?.filterKnowledgeListData.viewSelected,
                viewStructure: props?.filterKnowledgeListData.viewStructure,
                ticketCreatedCorporationId: props?.filterKnowledgeListData.ticketCreatedCorporationId,
                ticketCreatedProjectId: props?.filterKnowledgeListData.ticketCreatedProjectId,
            }, 
            props : {
                ...propsClone,
                componentName: Constant.COMPONENT_NAME.LIST_TICKET_KNOWLEDGE,
                panelType: Constant.PANEL_TYPE.KNOWLEDGE_TICKET_LIST,
                panelId: propsClone.panelId,
                projectSelectedId: props?.filterKnowledgeListData.projectIdKnowledgeSelected,
                visibilitySettingType: props?.filterKnowledgeListData?.visibilityKnowledgeAtom ? props?.filterKnowledgeListData?.visibilityKnowledgeAtom : props.visibilitySettingType,
                ticketCreatedCorporationId: props?.filterKnowledgeListData.ticketCreatedCorporationId,
                ticketCreatedProjectId: props?.filterKnowledgeListData.ticketCreatedProjectId,
            },
        }

        if (props?.filterKnowledgeListData.projectIdKnowledgeSelected !== projectInuseDetail.id  ) {
            // setIsShowVisibilityKnowledgeAtom(false);
            addNewPanelParams.visibilitySettingType = Constant.VISIBILITY_SETTING_TYPE.CUSTOMER
            addNewPanelParams.isCustomer = true
        }

        addNewPanel(addNewPanelParams)

        reloadKnowledgeDrilldownIsCustomerParams({
            isCustomer: addNewPanelParams.isCustomer
        });
    };

    const onClickUrlViewTicket = async (url) => {
        setIsLoading(true)
        const {
            orgDomain: affiliationOrganizationDomain,
            projectId: affiliationProject,
            ticketId: ticketIdOfUrl,
            withMessage
        } = await Utils.extractShareLinkInfo(url);

        await openShareLinkTicket(
            API,
            ticketIdOfUrl,
            affiliationProject,
            affiliationOrganizationDomain,
            currentUserDetail.id,
            projectInuseDetail.id,
            {
                ...props,
                setIsLoading,
                API,
                setIsOpenAccessDeniedPopup,
                setIsOpenPopupKnowledgeOff,
                setIsOpenNotFoundTicketPopup,
                addNewPanel,
                setLastUserAction,
                setPanelList,
                setProjectDetail: setProjectInuseDetail,
                userDetail: currentUserDetail,
                setUserDetail: setCurrentUserDetail,
                setShowPopupSingleButtonError
            },
            withMessage
        );
    }
    window.onClickUrlViewTicket = onClickUrlViewTicket;

    // ==================== useEffect: KBoard pending result ====================
    useEffect(() => {
        if (!chatThreadId) return;
        if (!Array.isArray(kboardPendingResult) || kboardPendingResult.length === 0) return;

        // Find items in the queue targeting this thread
        const myItems = kboardPendingResult.filter(item => item.targetThreadId === chatThreadId);
        if (myItems.length === 0) return;

        const consumePendingResults = async () => {
            // Remove consumed items from the queue, keep items for other threads
            const remainingItems = kboardPendingResult.filter(item => item.targetThreadId !== chatThreadId);
            if (remainingItems.length === 0) {
                resetKboardPendingResult();
            } else {
                setRecoil(kboardPendingResultAtom, remainingItems);
            }

            // Process each item sequentially
            for (const item of myItems) {
                const { payload, staticData } = item;
                const localHandleConnectData = {
                    ...staticData,
                    chatThreadId,
                    setListMessageContent,
                    setIsEnableBtnSend,
                    setIsShowButtonStop,
                    setIsOnlyRunChatAI,
                    setIsStopStreamContent,
                    setIdOfResponseMessage,
                    corporationDetail,
                    currentUserDetail,
                    setPanelList,
                    panelId: props.panelId,
                    tabId: props.tabId,
                    listMessageContent, 
                    setUsingChatGptModel,
                    setUsingReasoningEffort
                };
                await handleDataFromKboard(payload, localHandleConnectData);
            }
        };

        consumePendingResults();
    }, [kboardPendingResult, chatThreadId]); // eslint-disable-line react-hooks/exhaustive-deps

    // ==================== useEffect: Corporation subscription ====================
    useEffect(() => {
        if (!corporationSelected) return;

        let subscription;
        // subscription is assigned AFTER await getCorporationById (different corp branch). If cleanup
        // runs before the await resolves, nothing is left to unsubscribe => memory leak.
        let isCancelled = false;

        const listenEventUpdateSelectedCorporation = async () => {
            let selectedCorporationDetail =
            corporationSelected === corporationDetail?.id
                ? corporationDetail
                : await getCorporationById(null, corporationSelected);

            if (isCancelled) {
                return;
            }
            if (selectedCorporationDetail) {
                let subscriptionCorpId = corporationSelected;
                if (
                    [Constant.CORPORATION_CONTRACT_TYPE.GUEST, Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK].includes(selectedCorporationDetail.contractType)
                ) {
                    subscriptionCorpId = selectedCorporationDetail.inviter
                }
                subscription = onSubscriptionEventUpdateCorporation({
                    subscriptionCorpId,
                    setIsReloadPage: setIsReloadPage,
                    setCorporationDetail: setCorporationDetail
                });
            }
        };

        listenEventUpdateSelectedCorporation();

        return () => {
            isCancelled = true;
            if (subscription) {
                subscription?.unsubscribe();
            }
        };
    },[corporationSelected, corporationDetail])

    // ==================== useEffect: Load chat messages ====================
    useEffect(() => {
        if (Utils.isEmptyString(chatThreadId)) return;

        const controller = new AbortController();

        if (!Utils.isEmptyString(chatThreadId)) {
            let aiAutoLog = filterKnowledgeListData?.aiAutoLog;
            if (aiAutoLog) {
                setIsLoading(true);
                showLoadingMouse();
            }
            
            getListMessageChat(props?.API, chatThreadId, aiAutoLog?.ticketId).then(async result => {
                if (result === false) {
                    closePanelTab({
                        event: null,
                        panelType: Constant.PANEL_TYPE.OPEN_CHAT_AI,
                        panelId: props.panelId,
                        tabId: chatThreadId
                    })
                } 
                result = Utils.sortByCreatedAtAsc(result);
                const firstChatMsg = result[0];
                
                let threadStatus = firstChatMsg?.threadStatus;
                let tabNameChatAI = props?.tabNameChatAI || '';
                if (!Utils.isEmptyArray(result)) {
                    // Get Full_TabNameChatAI
                    tabNameChatAI = firstChatMsg?.content;
                    if (
                        Utils.isEmptyString(tabNameChatAI) &&
                        firstChatMsg.postType === Constant.POST_TYPE.IMAGE
                    ) {
                        tabNameChatAI = await getNameTabChatAiWhenFirstMsgNoContent(firstChatMsg);
                    }

                    if (aiAutoLog) {
                        aiAutoLog.tabName = firstChatMsg.content;
                        setAiAutoPromptTitle(firstChatMsg.ticketOutline || '');
                    }
                    let chatHistory = [];
                    let showContentMsg = ['MSG-AI-AUTO-LOG-PAUSE', 'MSG-AI-AUTO-LOG-RETRY', 'MSG-AI-AUTO-LOG-ERROR']
                    result?.forEach(message => {
                        if (message.role === 'user') {
                            let content = message.content;
                            let userName;
                            if (filterKnowledgeListData.isAiAssistantLog) {
                                userName = message.creatorId;
                            } else if (aiAutoLog) {
                                userName = `${message?.creatorName || ''} ${tr('(オート)')}`;
                            } else {
                                userName = Utils.getFullNameOfUser(
                                    Constant.LANGUAGE_TYPE.JP,
                                    currentUserDetail
                                );
                            }

                            chatHistory.push({
                                isFromMe: true,
                                user: userName,
                                dateTime: formatUserDateTime(message.createdAt, 'YYYY/MM/DD HH:mm', currentUserDetail?.userSetting),
                                content:
                                    aiAutoLog && showContentMsg.includes(content)
                                        ? trI18n(content)
                                        : content,
                                isHidden: aiAutoLog && content === 'MSG-AI-AUTO-LOG-REPLAY',
                                postType: message.postType || Constant.POST_TYPE.MSG,
                                id: message.id,
                                isHasKboardScreenCapture: message.isHasKboardScreenCapture,
                                isAiAssistantLog: !!filterKnowledgeListData.isAiAssistantLog
                            });
                        } else {
                            let reasoningData = [];
                            if (!Utils.isEmptyArray(message.reasoning)) {
                                reasoningData = message.reasoning.map(reasoning =>
                                    Utils.extractTitleAndContent(reasoning)
                                );
                                reasoningData.push({ isDone: true });
                            }

                            let aiMessage = {
                                isFromMe: false,
                                dateTime: formatUserDateTime(message.createdAt, 'YYYY/MM/DD HH:mm', currentUserDetail?.userSetting),
                                content: message.content,
                                postType: message.postType || Constant.POST_TYPE.MSG,
                                id: message.id,
                                reasoningData: reasoningData,
                                isHasKboardScreenCapture: message.isHasKboardScreenCapture,
                                isGeneratedFileError: message.isGeneratedFileError,
                                streamStatus: message.streamStatus || ''
                            };

                            if (message.streamStatus === Constant.STREAM_STATUS.WARNING || message.streamStatus === Constant.STREAM_STATUS.ERROR) {
                                aiMessage.isError = true;
                            }

                            if (filterKnowledgeListData.isOperatorPromptLog) {
                                aiMessage.user = message.creatorId;
                                aiMessage.isOperatorPromptLog = true;
                            }
                            if (filterKnowledgeListData.isAiAssistantLog) {
                                aiMessage.user = message.creatorId;
                                aiMessage.isAiAssistantLog = true;
                            }

                            chatHistory.push(aiMessage);
                        }
                    });

                    if (aiAutoLog && threadStatus === AiAutoConstant.AICHATTHREAD_LOG_STATUS.RUNNING) {
                        chatHistory.push({
                            isFromMe: false,
                            isLoadingMessage: true
                        })
                    }
                    setListMessageContent([...chatHistory])
                }

                let currentPanelList = cloneDeep(panelList);
                if (Utils.isEmptyArray(currentPanelList)) return;
                let currentPanelIndex = Utils.findIndexInArrayById(props.panelId, currentPanelList);
                if (currentPanelIndex === -1) return;

                let currentPanel = currentPanelList[currentPanelIndex];

                if (Utils.isEmptyArray(currentPanel.tabList)) return;
                let currentTabIndex = Utils.findIndexInArrayById(props.tabId, currentPanel.tabList);
                if (currentTabIndex === -1) return;
                
                // Update ticket outline
                currentPanelList[currentPanelIndex].tabList[currentTabIndex].chatThreadId = chatThreadId;

                //  optimize chatAi tabList
                const optimizeFilterKnowledgeListData = currentPanelList[currentPanelIndex].tabList[currentTabIndex].component.props?.filterKnowledgeListData
                if (optimizeFilterKnowledgeListData && optimizeFilterKnowledgeListData.organizationProject) {
                    delete optimizeFilterKnowledgeListData.organizationProject
                }
                currentPanelList[currentPanelIndex].tabList[currentTabIndex].component.props.filterKnowledgeListData = optimizeFilterKnowledgeListData
                currentPanelList[currentPanelIndex].tabList[currentTabIndex].component.props.tabNameChatAI = tabNameChatAI;
                currentPanelList[currentPanelIndex].tabList[currentTabIndex].tabNameChatAI = tabNameChatAI;

                if (aiAutoLog) {
                    currentPanelList[currentPanelIndex].tabList[currentTabIndex].component.props.tabNameChatAI = aiAutoLog.tabName;
                    currentPanelList[currentPanelIndex].tabList[currentTabIndex].tabNameChatAI = aiAutoLog.tabName;
                }
                
                setPanelList([...currentPanelList]);
            })
            .catch(e => console.log('getListMessageChat err: ', e))
            .finally(() => {
                if (aiAutoLog) {
                    setIsLoading(false);
                    hideLoadingMouse();
                }
            });

        }

        return () => {
            controller.abort();
        }

    }, [chatThreadId, props?.tabId]);

    // ==================== useEffect: Chat post subscription ====================
    useEffect(() => {
        let aiAutoLog = filterKnowledgeListData?.aiAutoLog;
        
        let subscriptionAiAuto;
        const handleSubscriptionCreateAiAutoChatPost = (threadId) => {
            let subscription;
            subscription = APIAmplify.graphql({
                query: onAIChatPostCreated,
                variables: { chatThreadId: threadId },
                authMode: Constant.AUTH_MODE_API_KEY
            }).subscribe({
                next: async res => {
                    let newChatPost = res.value.data.onAIChatPostCreated;
                    if (!aiAutoLog) {
                        if (newChatPost.role !== 'system' && newChatPost.creatorId !== 'chatGPTAsync') return;

                        setListMessageContent(prev => {
                            let listMsg = [...prev];

                            // Skip if message already exists in list
                            if (newChatPost.id && listMsg.some(msg => msg.id === newChatPost.id)) {
                                return prev;
                            }
    
                            let createMsg = {
                                dateTime: formatUserDateTime(newChatPost.createdAt, 'YYYY/MM/DD HH:mm', currentUserDetail?.userSetting),
                                content: newChatPost.content,
                                isFromMe: newChatPost.role === 'user',
                                postType: newChatPost.postType || Constant.POST_TYPE.MSG,
                                id: newChatPost.id,
                                isGeneratedFileError: newChatPost.isGeneratedFileError,
                                streamStatus: newChatPost.streamStatus || ''
                            };

                            if (newChatPost.streamStatus === Constant.STREAM_STATUS.WARNING || newChatPost.streamStatus === Constant.STREAM_STATUS.ERROR) {
                                createMsg.isError = true;
                            }

                            const currentLastMsg = listMsg[listMsg.length - 1];

                            if (
                                currentLastMsg &&
                                currentLastMsg.isFromMe === false &&
                                currentLastMsg.isLoadingMessage === true
                            ) {
                                listMsg[listMsg.length - 1] = createMsg;
                                listMsg.push(currentLastMsg);
                            } else {
                                listMsg.push(createMsg);
                            }
    
                            return listMsg;
                        });
                        return;
                    }
                   
                    if (newChatPost.content === 'MSG-AI-AUTO-LOG-PAUSE') {
                        newChatPost.content = trI18n('MSG-AI-AUTO-LOG-PAUSE')
                    }
                    
                    setListMessageContent(prev => {
                        let listMsg = [...prev];

                        // Skip if message already exists in list
                        if (newChatPost.id && listMsg.some(msg => msg.id === newChatPost.id)) {
                            return prev;
                        }

                        let createMsg = {
                            dateTime: formatUserDateTime(newChatPost.createdAt, 'YYYY/MM/DD HH:mm', currentUserDetail?.userSetting),
                            content: newChatPost.content,
                            isFromMe: newChatPost.role === 'user',
                            id: newChatPost.id,
                            streamStatus: newChatPost.streamStatus || ''
                        };

                        if (newChatPost.streamStatus === Constant.STREAM_STATUS.WARNING || newChatPost.streamStatus === Constant.STREAM_STATUS.ERROR) {
                            createMsg.isError = true;
                        }

                        if (filterKnowledgeListData.isOperatorPromptLog) {
                            createMsg.user = newChatPost.creatorId;
                            createMsg.isOperatorPromptLog = true;
                        }
                        if (filterKnowledgeListData.isAiAssistantLog) {
                            createMsg.user = newChatPost.creatorId;
                            createMsg.isAiAssistantLog = true;
                        }
                        const currentLastMsg = listMsg[listMsg.length - 1];
                        // case: replace msg PAUSE to gpt loading
                        if (
                            currentLastMsg &&
                            currentLastMsg.isFromMe === false &&
                            currentLastMsg.isLoadingMessage === true
                        ) {
                            listMsg[listMsg.length - 1] = createMsg;
                        }
                        // case: push msg Replay & msg gpt loading
                        else if (
                            createMsg.content === 'MSG-AI-AUTO-LOG-REPLAY'
                        ) {
                            createMsg.isHidden = true;
                            listMsg.push(createMsg);
                            listMsg.push({
                                isFromMe: false,
                                isLoadingMessage: true
                            });
                            
                        }
                        else {
                            listMsg.push(createMsg);
                        }
                        return listMsg;
                    })
                },
                error: error => {
                    console.log('subscriptionAiAuto error:', error);
                }
            });
            return subscription
        }
        if (!Utils.isEmptyString(chatThreadId)) {
            subscriptionAiAuto = handleSubscriptionCreateAiAutoChatPost(
                chatThreadId
            );
        }
        return () => {
            if (subscriptionAiAuto) {
                subscriptionAiAuto?.unsubscribe();
            }
        };
    }, [chatThreadId, props?.tabId]);

    // ==================== useEffect: Fetch AI service options for chatAiPanel ====================
    useEffect(() => {
        if (!filterKnowledgeListData) return;
        if (!chatThreadId && !props?.tabId) return;

        fetchChatAiConfigurations({
            corporationInuseDetail: corporationDetail,
            projectInuseDetail,
            userId: currentUserDetail.id,
            filterKnowledgeListData
        }).then(aiConfigurations => {
            const { listChatGptModel, listMcpInProject, listSelectedMcp} = aiConfigurations
            setChatGPTModelListOptions(listChatGptModel);
            setMcpServerOptions(listMcpInProject);
            setSelectedMcpServers(listSelectedMcp);
        });

    }, [filterKnowledgeListData?.projectSelectedId, chatThreadId, props?.tabId, corporationDetail?.id, projectInuseDetail?.id, currentUserDetail?.id]);

    // ==================== useEffect: Load project info ====================
    useEffect(() => {
        let aiAutoLog = filterKnowledgeListData?.aiAutoLog;
        if (aiAutoLog) return;
        if (!chatThreadId && !props?.tabId) return;

        (async () => {
            setIsLoading(true);
            await getProjectInfo(
                props?.API,
                filterKnowledgeListData?.projectIdKnowledgeSelected,
                setProjectInfo,
                corporationDetail,
                setTitleTicket,
                setPromptInternalTicket,
                setPromptExternalTicket,
                setBasicPrompt,
                filterKnowledgeListData,
                setIsReloadPage,
                setCorporationSelected,
                projectInuseDetail.id,
                setIsUsingKnowledgeService,
                setProjectInuseDetail
            );
            setIsLoading(false);
        })();
    }, [
        props?.filterKnowledgeListData?.projectIdKnowledgeSelected,
        triggerReload,
        props?.filterKnowledgeListData?.ticketCreatedProjectId,
        props?.filterKnowledgeListData?.ticketCreatedCorporationId,
        chatThreadId, props?.tabId
    ]);

    // ==================== Render ====================
    return (
        <div className="chat-ai-container">
            <LoadingPanel isLoading={isLoading} />
            <FirstMessageContent tabNameChatAI={props?.tabNameChatAI} />
            {!isAiAutoLog &&  (
                <GroupButtonKnowledge
                    chatThreadId={chatThreadId}
                    projectInfo={projectInfo}
                    panelId={props.panelId}
                    tabId={props.tabId}
                    reOpenKnowledgePanel={reOpenKnowledgePanel}
                    projectIdKnowledgeSelected={filterKnowledgeListData?.projectIdKnowledgeSelected}
                    isInvalidPrecondition={isInvalidPrecondition}
                    initHitNumber={initHitNumber}
                    isUsingKnowledgeService={isUsingKnowledgeService}
                    toggleUsingKnowledgeTicketList={toggleUsingKnowledgeTicketList}
                    setToggleUsingKnowledgeTicketList={setToggleUsingKnowledgeTicketList}
                    usingChatGptModel={usingChatGptModel}
                    setUsingChatGptModel={setUsingChatGptModel}
                    selectedMcpServers={selectedMcpServers}
                    usingReasoningEffort={usingReasoningEffort}
                    setUsingReasoningEffort={setUsingReasoningEffort}
                    chatGPTModelListOptions={chatGPTModelListOptions}
                />
            )}
            <div className="group-chat-input">
                <ListMessageChatAI
                    listMessageContent={listMessageContent}
                    setListMessageContent={setListMessageContent}
                    setIsLoadingMessage={setIsLoadingMessage}
                    isLoadingMessage={isLoadingMessage}
                    chatThreadId={chatThreadId}
                    isEnableBtnSend={isEnableBtnSend}
                    setIsEnableBtnSend={setIsEnableBtnSend}
                    panelId={props.panelId}
                    corporationDetail={corporationDetail}
                    currentUserDetail={currentUserDetail}
                    setUserSelectedPrompt={setUserSelectedPrompt}
                    idOfResponseMessage={idOfResponseMessage}
                    setIdOfResponseMessage={setIdOfResponseMessage}
                    projectInfo={projectInfo}
                    projectInuseDetail={projectInuseDetail}
                    isAiAutoLog={isAiAutoLog}
                    isAiAssistantLog={!!filterKnowledgeListData?.isAiAssistantLog}
                    aiAutoPromptTitle={aiAutoPromptTitle}
                    usingChatGptModel={usingChatGptModel}
                    usingReasoningEffort={usingReasoningEffort}

                    isShowButtonStop={isShowButtonStop}
                    setIsShowButtonStop={setIsShowButtonStop}
                    isOnlyRunChatAI={isOnlyRunChatAI}
                    setIsOnlyRunChatAI={setIsOnlyRunChatAI}

                    setStreamedContent={setStreamedContent}
                    streamedContent={streamedContent}

                    isStopStreamContent={isStopStreamContent}
                    setIsStopStreamContent={setIsStopStreamContent}
                    setReasoningDataStream={setReasoningDataStream}
                    reasoningDataStream={reasoningDataStream}
                />
                {!isAiAutoLog && (
                    <InputChatAI
                        setListMessageContent={setListMessageContent}
                        panelId={props.panelId}
                        tabId={props.tabId}
                        API={props?.API}
                        projectInfo={projectInfo}
                        setTriggerReload={setTriggerReload}
                        filterKnowledgeListData={filterKnowledgeListData}
                        basicPrompt={basicPrompt}
                        isEnableBtnSend={isEnableBtnSend}
                        setIsEnableBtnSend={setIsEnableBtnSend}
                        listMessageContent={listMessageContent}
                        isAiAssistantLog={!!filterKnowledgeListData?.isAiAssistantLog}
                        resetSearchCondition={resetSearchCondition}
                        corporationSelected={corporationSelected}
                        tabNameChatAI={props?.tabNameChatAI}
                        titleTicket={titleTicket}
                        setUserSelectedPrompt={setUserSelectedPrompt}
                        userSelectedPrompt={userSelectedPrompt}
                        promptInternalTicket={promptInternalTicket}
                        promptExternalTicket={promptExternalTicket}
                        setIsOpenModalReloadPage={setIsOpenModalReloadPage}
                        isLoading={isLoading}
                        setIsLoading={setIsLoading}
                        usingBasicPrompt={usingBasicPrompt}
                        idOfResponseMessage={idOfResponseMessage}
                        setIdOfResponseMessage={setIdOfResponseMessage}
                        isUsingKnowledgeService={isUsingKnowledgeService}
                        toggleUsingKnowledgeTicketList={toggleUsingKnowledgeTicketList}
                        setToggleUsingKnowledgeTicketList={setToggleUsingKnowledgeTicketList}
                        usingChatGptModel={usingChatGptModel}
                        setUsingChatGptModel={setUsingChatGptModel}
                        selectedMcpServers={selectedMcpServers}
                        setSelectedMcpServers={setSelectedMcpServers}
                        mcpServerOptions={mcpServerOptions}
                        usingReasoningEffort={usingReasoningEffort}
                        setUsingReasoningEffort={setUsingReasoningEffort}
                        reOpenKnowledgePanel={reOpenKnowledgePanel}
                        isInvalidPrecondition={isInvalidPrecondition}
                        initHitNumber={initHitNumber}
                        chatGPTModelListOptions={chatGPTModelListOptions}

                        isShowButtonStop={isShowButtonStop}
                        setIsShowButtonStop={setIsShowButtonStop}
                        setIsOnlyRunChatAI={setIsOnlyRunChatAI}
                        streamedContent={streamedContent}
                        setIsStopStreamContent={setIsStopStreamContent}
                        reasoningDataStream={reasoningDataStream}
                        setReasoningDataStream={setReasoningDataStream}
                    />
                )}
            </div>
            <ConfirmDialog
                isOpen={isReloadPage}
                msgConfirm={trI18n('COMMSG030')}
                okCallBack={() => window.location.reload()}
            />

            <ConfirmDialog
                isOpen={isInvalidSearchCondition}
                msgConfirm={trI18n('MSG-ERROR-WHEN-KNOWLEDGE-BEING-USED-BE-HIDDEN-OR-DELETED')}
                okCallBack={() => {
                    updateChatAIInvalidPreconditionStatus(
                        panelList,
                        setPanelList,
                        props.panelId,
                        props.tabId,
                        true
                    );
                    setIsInvalidSearchCondition(false);
                }}
            />

            <DataChangePleaseReloadModal
                isOpen={isOpenModalReloadPage}
                setIsOpen={setIsOpenModalReloadPage}
            />
            <ConfirmDialog
                isOpen={isOpenPopupKnowledgeOff}
                msgConfirm={trI18n('USER14MSG028')}
                okCallBack={e => {
                    setIsOpenPopupKnowledgeOff(false);
                }}
                textSubmit={tr('はい')}
            />
            <ConfirmDialog
                isOpen={isOpenAccessDeniedPopup}
                msgConfirm={trI18n('KNOWDEMSG005')}
                okCallBack={e => setIsOpenAccessDeniedPopup(false)}
                textSubmit={trI18n('CM-BUTTON-OK')}
            />
            <ConfirmDialog
                isOpen={isOpenNotFoundTicketPopup}
                msgConfirm={trI18n('MSG-CM-DELETED-CONTENT')}
                okCallBack={e => setIsOpenNotFoundTicketPopup(false)}
                textSubmit={trI18n('CM-BUTTON-OK')}
            />
            <ConfirmDialog
                isOpen={showPopupSingleButtonError?.isShow}
                msgConfirm={showPopupSingleButtonError?.message}
                okCallBack={e =>
                    setShowPopupSingleButtonError(pre => {
                        return {
                            ...pre,
                            isShow: false
                        };
                    })
                }
                textSubmit={showPopupSingleButtonError?.confirmTxt}
            />
        </div>
    );
}
